import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import ErrorBoundaryWrapper from './components/ErrorBoundaryWrapper/ErrorBoundaryWrapper';

import 'primeicons/primeicons.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";

import "./index.css"

// Import Pages
import HomePage from './pages/HomePage/HomePage'
import Under from './pages/Under/Under'
import ErrorPage from './pages/ErrorPage/ErrorPage'
import ApiPage from './pages/ApiPage/ApiPage'
import HelpPage from './pages/HelpPage/HelpPage'
import ResultPage from './pages/ResultPage/ResultPage'
import AboutPage from './pages/AboutPage/AboutPage'
import FaqPage from './pages/FaqPage/FaqPage'
import LogPage from './pages/LogPage/LogPage'
import BrowsePage from './pages/BrowsePage/BrowsePage'
import CalculationPage from './pages/CalculationPage/CalculationPage'
import PathfinderPage from './pages/PathfinderPage/PathfinderPage'
import GlossaryPage from './pages/GlossaryPage/GlossaryPage'
import MaintenancePage from './pages/MaintenancePage/MaintenancePage'
import MCPPage from './pages/MCPPage/MCPPage'
import ProjectionPage from './pages/ProjectionPage/ProjectionPage'

const router = createBrowserRouter([ {
      path: "/",
      element: <HomePage/>,
      errorElement: <ErrorPage error={"Sorry for the inconvenience, we're working on it!"}/>
    },
    {
      path: "/under/",
      element: <Under/>,
    },
    {
      path: "/calculation/",
      element: <CalculationPage/>,
    },
    {
      path: "/pathfinder/",
      element: <PathfinderPage/>,
    },
    {
      path: "/help/",
      element: <HelpPage/>,
    },
    {
      path: "/about/",
      element: <AboutPage/>,
    },
    ,
    {
      path: "/browse/",
      element: <BrowsePage/>,
    },
    {
      path: "/glossary/",
      element: <GlossaryPage/>,
    },
     {
      path: "/faq/",
      element: <FaqPage/>,
    },
    {
      path: "/api/",
      element: <ApiPage/>,
    },
    {
      path: "/mcp/",
      element: <MCPPage/>,
    },
    {
      path: "/projection/",
      element: <ProjectionPage/>,
    },
    {
      path: "/log/",
      element: <LogPage/>,
    },
    {
      path: "/explore/",
      element: (
      <ErrorBoundaryWrapper>
        <ResultPage />
      </ErrorBoundaryWrapper>
      )
    },
    {
      path: "*",
      element: <ErrorPage error={"Page not found. This page doesn't exist!"}/>
    },
  ],
 );

createRoot(document.getElementById("root")).render(
<RouterProvider router={router}/>);
